import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { FC } from "react";
import { CourseFilter, Programme } from "../../../services/type";
import CourseHeader from "../CourseHeader";
import CourseFilters from "./CourseFilters";

type Props = {
    filters: CourseFilter;
    setFilters: (filter: CourseFilter) => void;
    handleOpenDialog: () => void;
    handleDateChange: (newDate: string) => void;
    programme?: Programme;
    isMobileRaceOpen: boolean;
    selectedDate: string;
};

const DialogMobileFilter: FC<Props> = ({ filters, setFilters, programme, isMobileRaceOpen, handleOpenDialog, selectedDate, handleDateChange }) => {


    return <Dialog
        open={isMobileRaceOpen}
        fullScreen
        onClose={handleOpenDialog}
    >
        <CourseHeader
            selectedDate={selectedDate}
            handleDateChange={handleDateChange}
            program={programme}
        />

        {/* CONTENT SCROLLABLE */}
        <DialogContent
            dividers
            sx={{
                overflow: 'hidden',
                pt: 0,
                px: 0,
                pb: 10, // laisse de la place au bouton du bas
            }}
        >
            <CourseFilters
                filter={filters}
                setFilter={setFilters}
                programme={programme}
            />
        </DialogContent>

        {/* ACTIONS FIXES EN BAS */}
        <DialogActions
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                p: 0,
                bgcolor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                justifyContent: 'center',
                zIndex: 1300,
            }}
        >
            <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleOpenDialog}
                sx={{
                    borderRadius: 0,
                    height: 48,
                    fontWeight: 600,
                }}
            >
                Fermer
            </Button>
        </DialogActions>
    </Dialog>
}

export default DialogMobileFilter